/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
    InvitationAction,
    STORE_INVITATIONS,
    REMOVE_INVITATION,
    RemoveInvitationPayload,
    RemoveInvitationAction
} from "../actions/actions";
import { Invitation } from "../../models/model";

export function invitations(state: Invitation[] = [], action: InvitationAction & RemoveInvitationAction): Invitation[] {
    switch (action.type) {
        case STORE_INVITATIONS: {
            return action.payload;
        }
        case REMOVE_INVITATION: {
            const payload = action.payload as RemoveInvitationPayload;
            return [
                ...state.filter(
                    e =>
                        e.offeringId != payload.offeringId ||
                        e.partnerId.type != payload.partnerId.type ||
                        e.partnerId.value != payload.partnerId.value
                )
            ];
        }
        default:
            return state;
    }
}
